export const DEFAULT_PAYMENT_AMOUNT = 10
export const DEFAULT_DAILY_LIMIT = 1000
export const DEFAULT_TRIGGER_BALANCE = 10
export const LOW_BALANCE = 0.5
